import {
  ApiResponseBoolean,
  CreatePushProductPlanRequest,
  DakeGetQrCodeRsp,
  DakeLibraryListRsp,
  DakeLibraryReq,
  DakeProdPromoTaskCalendarReq,
  DakeProdPromoTaskCalendarRsp,
  dakeProdPromoTaskListReq,
  DakeProdPromoTaskListRsp,
  DakeProdPromoTaskReq,
  DakeProdPromoTaskRsp,
  DakeStopProdPromoTaskReq,
  GetGroupListRequest,
  GetGroupListResponse,
  GetQrCodeRequest,
  QueryWxGroupRequest,
  QueryWxGroupResponse,
} from "@/data-contracts";
import request, { _POST } from "@/services/request";

/**
 * 获取商品推广任务日历
 * */
const getProdPromoTaskCalendar = (params?: DakeProdPromoTaskCalendarReq) => {
  return request<DakeProdPromoTaskCalendarRsp, DakeProdPromoTaskCalendarReq>(
    _POST,
    "/dake-biz/v1/prod_promo_task/calendar"
  )(params ?? {});
};

/**
 * 获取商品推广任务列表
 * */
const getProdPromoTaskList = (params?: dakeProdPromoTaskListReq) => {
  return request<DakeProdPromoTaskListRsp, dakeProdPromoTaskListReq>(
    _POST,
    "/dake-biz/v1/prod_promo_task/list"
  )(params || {});
};

/**
 * 获取商品素材列表
 * */
const getLibraryPage = (params?: DakeLibraryReq) => {
  return request<DakeLibraryListRsp, DakeLibraryReq>(_POST, "/dake-biz/v1/library/page")(params || {});
};

/**
 * 获取商品推广任务详情
 * */
const getProdPromoTaskDetail = (params?: DakeProdPromoTaskReq) => {
  return request<DakeProdPromoTaskRsp, DakeProdPromoTaskReq>(
    _POST,
    "/dake-biz/v1/prod_promo_task/detail"
  )(params || {});
};

/**
 * 停止商品推广任务
 * */
const stopProdPromoTask = (params?: DakeStopProdPromoTaskReq) => {
  return request<ApiResponseBoolean, DakeStopProdPromoTaskReq>(
    _POST,
    "/dake-biz/v1/prod_promo_task/stop"
  )(params || {});
};

/**
 * 根据日期查询当天有推送任务的群
 * */
const getProdPromoTaskWxGroup = (params?: QueryWxGroupRequest) => {
  return request<QueryWxGroupResponse, QueryWxGroupRequest>(
    _POST,
    "/dake-biz/v1/prod_promo_task/wxGroup"
  )(params || {});
};

/**
 * 查询群
 * */
const getWxGroupList = (params?: GetGroupListRequest) => {
  return request<GetGroupListResponse, GetGroupListRequest>(_POST, "/dake-biz/v1/channel_group_page")(params || {});
};

/**
 * 获取商品素材列表
 * */
const getLibraryList = (params?: DakeLibraryReq) => {
  return request<DakeLibraryListRsp, DakeLibraryReq>(_POST, "/dake-biz/v1/library/page")(params || {});
};

/**
 * 批量创建推送任务
 * */
const batchCreatePushProductPlan = (params: CreatePushProductPlanRequest) => {
  return request<unknown, CreatePushProductPlanRequest>(
    _POST,
    "/dake-biz/v1/push_plan/group/batch_create_push_product_plan"
  )(params);
};

/**
 * 获取小程序码
 * */
const getQrCode = (params: GetQrCodeRequest) => {
  return request<DakeGetQrCodeRsp, GetQrCodeRequest>(_POST, "/dake-biz/mp/get_qr_code")(params);
};

const selectionCalendarApis = {
  getProdPromoTaskCalendar,
  getProdPromoTaskList,
  getProdPromoTaskDetail,
  getLibraryPage,
  stopProdPromoTask,
  getProdPromoTaskWxGroup,
  getWxGroupList,
  getLibraryList,
  batchCreatePushProductPlan,
  getQrCode,
};

export default selectionCalendarApis;
